import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import * as State from '@shared/state';
import { ListsComponent } from '../../lists.shared.component';
import { IOrder } from '@shared/state';

@Component({
    selector: 'shared-list-for-order-types',
    templateUrl: './list-for-order-types.shared.component.html',
    styleUrls: ['./list-for-order-types.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListForOrderTypesComponent extends ListsComponent {
    @Input() public orderTypes: State.IOrderType;

    constructor() {
        super();
        this.placeholders = 1;
    }

    public get isEmpty(): boolean {
        return !this.orderTypes || this.orderTypes?.data?.length === 0;
    }

    public trackBy(index: number, item: IOrder): number {
        return item?.Id || index;
    }
}
